import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LgvAPIService, LgvSnapshotHelper, NotificationService, LgvClientService, LgvUserService } from '../../../../core/core.module';
import { HttpClient } from "@angular/common/http";
import { first, takeUntil } from 'rxjs/operators';
import { environment as env } from '../../../../../environments/environment';
import { LgvModel } from '../../../../data-models/longevity.model';
import { MatRadioChange } from '@angular/material/radio';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GreaterThanZero } from '../../../../core/utility/lgv-form-validator';

@Component({
    selector: 'edit-loan-popup',
    templateUrl: 'edit-loan-popup.component.html',
})

export class EditLoanPopup implements OnInit, OnDestroy, AfterViewInit {
    isFirstLoan = true;
    //EditModel: LoanEditModel;
    IsRefi: boolean = false;
    LoanForm: UntypedFormGroup;
    IsReady: boolean = false;
    onDestroy$ = new Subject();
    loanTypeList$ = this.LgvClientSvc.getLoanTypes();
    loanPurposeList$ = this.LgvClientSvc.getLoanPurpose();
    loanAnalysis: LgvModel.LoanAnalysis;

    constructor(
        public dialogRef: MatDialogRef<EditLoanPopup>,
        private http: HttpClient,
        private LgvClientSvc: LgvClientService,
        private FB: UntypedFormBuilder,
        public SSHlpr: LgvSnapshotHelper,
        public Notifications: NotificationService,
        public LgvUserSvc: LgvUserService,
        private LgvApiSvc: LgvAPIService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.LoanForm = this.FB.group({
            estimatedBalance: [null, [Validators.required, GreaterThanZero()]],
            interestRate: [null, [Validators.required, GreaterThanZero()]],
            originalLoanAmount: [0],
            closingDate: [null],
            loanTerm: [null],
            loanTypeId: [null],
            otherLoanBalance: [null, []]
        });

        this.loanAnalysis = this.data?.loan?.loanAnalysis || this.SSHlpr.LA;
    }

    ngAfterViewInit(): void {
        let model = {
            estimatedBalance: 0,
            interestRate: 0,
            originalLoanAmount: 0,
            closingDate: null,
            loanTerm: 0,
            loanPurposeTypeId: '',
            loanTypeId: '',
            otherLoanBalance: 0
        }
        try {
            const estimatedBalance = !this.SSHlpr.Loan?.loanInfo?.clientEstimatedBalance ? this.loanAnalysis.estimatedBalance :
            this.SSHlpr.Loan?.loanInfo?.clientEstimatedBalance;
            model.estimatedBalance = Math.round(estimatedBalance);
            model.interestRate = this.loanAnalysis.interestRate;
            model.otherLoanBalance = this.SSHlpr.Loan.loanInfo.otherLoanBalance;
            this.IsRefi = this.SSHlpr.Loan.loanPurposeType.name.toLocaleLowerCase() !== "purchase";
        }
        catch (ex) {
        }

        this.isFirstLoan = this.data?.isFirstLoan;

        if (this.isFirstLoan) {
            this.LoanForm.controls['closingDate'].setValidators([Validators.required]);
            this.LoanForm.controls['originalLoanAmount'].setValidators([Validators.required]);
            this.LoanForm.controls['loanTerm'].setValidators([Validators.required]);
            this.LoanForm.controls['loanTypeId'].setValidators([Validators.required]);
            model.originalLoanAmount = this.loanAnalysis?.totalMortgageLoanAmount;
            model.closingDate = this.loanAnalysis?.closedDate;
            model.loanTerm = this.loanAnalysis?.loanTerm;

            this.loanTypeList$.pipe(first()).subscribe((lt) => {
                model.loanTypeId = lt.find(lt => lt.name === this.loanAnalysis?.loanType.toUpperCase())?.id;
                this.LoanForm.patchValue(model);
                this.IsReady = true;

            });
        }
        //this.LoanForm.patchValue(model);
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    OnUpdateLoan() {
        let model = this.LoanForm.getRawValue();

        this.IsReady = true;

        let loanID = this.loanAnalysis.loanId;
        let bldUrl = `${env.LgvApiBaseUrl}/user/client/loans/${loanID}`;
        if (!this.LgvApiSvc.IsClient) {
            bldUrl = `${env.LgvApiBaseUrl}/clients/${this.data.client}/loans/${loanID}`;
        }

        this.http.patch<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            //console.log('Result:');
            //console.log(x);
            if (!this.LgvApiSvc.IsClient) {
                this.LgvClientSvc.LoadSnapshotForNonClient(this.data.client, true);
            } else {
                this.LgvClientSvc.LoadSnapshotForClient();
            }

            this.onNoClick();
            this.IsReady = false;

            this.LgvClientSvc.PostPageClick("Client updated loan information").pipe(first()).subscribe();

        },
            err => {
                this.Notifications.error("There was an error trying to update your Loan Info.")
                this.IsReady = false;
                this.onNoClick();
            }
        );



    }

    OnIsRefiChange(event: MatRadioChange) {
        this.IsRefi = event.value == 'refi';
    }

}

export class LoanEditModel {
    //purchasePrice: number;
    interestRate: number;
    estimatedBalance: number;
    otherLoanBalance: number;
}
